import * as React from 'react';

// tslint:disable:max-line-length
export const CafeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M11.714 13.044l1.33-1.33 2.405 2.403-1.331 1.331zM14.783 2.158a.941.941 0 0 0-1.33 0L8.47 7.14l-.884-.885.746-.745a.47.47 0 0 0 0-.667L4.568 1.08a.471.471 0 0 0-.666.666l2.962 2.96-.746.747L3.157 2.49a.471.471 0 0 0-.667.667l2.962 2.96-.746.747-2.961-2.962a.471.471 0 0 0-.666.666l3.764 3.765a.47.47 0 0 0 .667 0l.745-.746.885.884-5.647 5.647 1.33 1.33 3.765-3.764 1.246 1.246a.941.941 0 0 0 1.331 0l5.618-5.617a3.643 3.643 0 0 0 0-5.155z" />
    </g>
  </svg>
);
